<template>
    <div class="confirm-information">
        <!-- :show-close="false" -->
        <el-dialog :visible.sync="centerDialogVisible" width="30%" center :close-on-click-modal="false"
            style="margin-top: 15vh" :close-on-press-escape="false">
            <div class="confirm-information-box">
                <div class="confirm-information-title" style="color: #21BD99">修改信息</div>
                <div class="confirm-information-content">
                    <!-- <div class="info-item">
                        <div class="info-name-title flex-align-center">姓名：</div>
                        <el-input size="large" v-model="nameInput" placeholder="请输入姓名"
                            ></el-input>
                    </div> -->
                    <div class="info-item ">
                        <div class="info-name-title flex-align-center">学校：</div>
                        <el-select v-model="schInput" size="large" filterable remote reserve-keyword placeholder="请输入学校全称"
                            :remote-method="getuserRegistrationOptionSchool" :loading="Sch_loading" clearable
                            @change="schoolChange">
                            <el-option v-for="item in filteredSchools" :key="item.id" :label="item.name"
                                :value="item.name" />
                        </el-select>
                    </div>
                    <div class="info-item ">
                        <div class="info-name-title flex-align-center">班级：</div>
                        <el-cascader ref="myCascader1" v-model="selectedClass" placeholder="请选择班级" size="large"
                            :options="classList" :props="props" collapse-tags clearable
                            @change="handleChange"></el-cascader>
                    </div>
                    <div class="info-item flex-align">
                        <div class="info-name-title flex-align-center"></div>
                        <div class="tags-container flex-align" v-if="ClassNamesByIdList.length > 0">
                            <el-tag type="success" v-for="(item, index) in ClassNamesByIdList" :key="index">{{ item }}
                            </el-tag>
                        </div>
                    </div>

                </div>
            </div>
            <span slot="footer" class="dialog-footer flex-align-center">
                <div class="ModifyInformation Mod-btn footer-btn flex-align-center" @click="cancel">取消</div>
                <div class="Confirm Confirm-btn footer-btn flex-align-center" @click="confirm">确认</div>

            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    //import引入组件才能使用
    components: {},
    props: ['UserInfo_data'],
    data() {
        return {
            centerDialogVisible: false,
            nameInput: '',
            schInput: '',
            sch_Idlit: [],
            class_Idlit: [],
            ModificationType: true,
            Sch_loading: false,
            props: {
                multiple: true,
                emitPath: false,
                value: 'id',
                label: 'name',
                children: 'children'
            },
            schoolList: [],
            filteredSchools: [],
            classList: [],
            selectedClass: '',
            postclassList: null,
            classNameStr: ['一年级1班', '二年级1班', '三年级1班', '四年级1班', '五年级1班', '六年级1班'],
            ClassNamesByIdList: []
        };
    },
    // 计算属性
    computed: {},
    // 监听data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        async openDialog(data) {
            //判断个人信息是否学校是否为空
            this.nameInput = this.UserInfo_data.name; //当前账号姓名
            await this.getschoolList();//获取所有学校列表
            this.RequestCollection();
            // if (this.UserInfo_data.schoolId != null) {
            //     await this.getSchoolIdbyUserId();//获取当前账号学校id列表
            //     await this.getclassByTree();//通过学校id获取班级列表
            //     await this.getClassIdbyUserId();//获取当前账号班级id列表
            // }
            this.centerDialogVisible = true;

        },
        async RequestCollection() {
            await this.getschoolList();//获取所有学校列表
            if (this.UserInfo_data.schoolId != null) {
                await this.getSchoolIdbyUserId();//获取当前账号学校id列表
                await this.getclassByTree();//通过学校id获取班级列表
                await this.getClassIdbyUserId();//获取当前账号班级id列表
            }
        },
        async getSchoolIdbyUserId() {//获取当前账号学校id列表
            let resData = await this.$Api.Home.getSchoolIdbyUserId();
            this.sch_Idlit = resData.data;
            this.getschoolData(resData.data);
        },
        async getschoolList() {//获取所有学校列表
            let resData = await this.$Api.Home.getschoolList();
            this.schoolList = resData.data;
        },
        getschoolData(data) { //获取默认学校名称列表
            let selectedSchools = this.schoolList.filter(school => data.includes(school.id)).map(school => school.name);
            this.schInput = selectedSchools[0];
            console.log('选择的学校:', selectedSchools);

        },
        schoolChange(data) {
            this.selectedClass = '';
            this.classList = [];
            const targetSchool = this.schoolList.find(school => school.name == data);
            const schoolId = targetSchool ? targetSchool.id : null;
            this.sch_Idlit = [schoolId];
            if (schoolId != null) {
                this.getclassByTree();//通过学校id获取班级列表
            }
        },
        async getClassIdbyUserId() {//获取当前账号学校id列表
            let resData = await this.$Api.Home.getClassIdbyUserId();
            console.log('获取当前账号学校id列表', resData);
            this.class_Idlit = resData.data;
            this.selectedClass = this.class_Idlit;
            this.ClassNamesByIdList = this.findClassNamesByIds(this.classList, this.selectedClass)
            // this.getsclassData();
        },
        getsclassData(nodeList, targetIdSet) { //获取默认班级名称列表
            const result = [];
            for (const node of nodeList) {
                if (targetIdSet.has(node.id)) {
                    result.push(node);
                }
                if (node.children && Array.isArray(node.children) && node.children.length > 0) {
                    const foundInChildren = this.getsclassData(node.children, targetIdSet);
                    result.push(...foundInChildren);
                }
            }

            return result;
        },
        async getclassByTree() {//通过学校id获取班级列表
            console.log('通过学校id获取班级列表', this.sch_Idlit);

            let data = {
                schoolList: this.sch_Idlit,
            }
            try {
                let resData = await this.$Api.Home.getclassByTree(data);
                if (resData && resData.data) {
                    this.classList = resData.data;
                }
            } catch (error) {
                console.error('接口请求错误:', error);
            }

        },
        async getuserRegistrationOptionSchool(query) {
            if (query !== '') {
                const filteredSchools = this.schoolList.filter(school =>
                    school.name.includes(query)
                );
                this.filteredSchools = filteredSchools;
            } else {
                // 如果搜索关键字为空，返回所有学校
                this.filteredSchools = [];
            }
        },
        sch_DataProcessing() {//处理提交学校数据
            const result = this.schoolList
                .filter(school => this.schInput.includes(school.name))
                .map(school => school.id);
            console.log('sch_DataProcessing', result);
            return result;

        },
        class_DataProcessing() {//处理提交班级数据
            let result = this.selectedClass.map(item => item[1]);
            console.log('class_DataProcessing', result);
            return result;
        },
        async bindClass() {
            // console.log('this.schInput', this.schInput);
            // console.log('this.selectedClass', this.selectedClass);
            if (this.schInput == '') {
                this.$message({
                    message: '学校不能为空',
                    type: 'error',
                    customClass: 'my-message',
                    center: true
                });
                return;
            } else if (this.selectedClass == '') {
                this.$message({
                    message: '班级不能为空',
                    type: 'error',
                    customClass: 'my-message',
                    center: true
                });
                return;

            }
            console.log('this.postclassList', this.postclassList);

            if (this.postclassList == null) {
                const targetIdSet = new Set(this.class_Idlit); // new Set([1, 2, 3])
                const foundNodes = this.getsclassData(this.classList, targetIdSet);
                this.postclassList = foundNodes;
                console.log('this.postclassList', this.postclassList);

            }
            // 处理提交信息数据
            let data = {
                // teacherName: this.nameInput,
                schoolList: this.sch_DataProcessing(),
                classList: this.postclassList,
            };
            console.log('bindClass data', data);
            try {
                let resData = await this.$Api.Home.bindClass(data);
                if (resData && resData.data) {
                    console.log('提交成功', resData.data);
                    this.$message({
                        message: '提交成功',
                        type: 'success',
                        customClass: 'my-message',
                        center: true
                    });
                    this.centerDialogVisible = false;
                    this.ModificationType = true;
                    this.$emit('custom-event');

                }
            } catch (error) {
                console.error('接口请求错误:', error);
            }

        },
        confirm() {//提交信息
            this.bindClass();
            // this.centerDialogVisible = false;

            // this.ModificationType = true;
        },
        ModifyInformation() {//修改信息
            this.ModificationType = false;
        },
        cancel() {//取消
            this.centerDialogVisible = false;
            // this.ModificationType = true;
        },
        handleChange() {
            const checkedNodes = this.$refs.myCascader1.getCheckedNodes();
            console.log('所有选中节点:', checkedNodes);
            let dataArr = [];
            for (let i = 0; i < checkedNodes.length; i++) {
                if (checkedNodes[i].level == 3) {
                    dataArr.push(checkedNodes[i].data)
                }
            }
            this.postclassList = dataArr;
            console.log('dataArr', dataArr);
            this.ClassNamesByIdList = this.findClassNamesByIdsPuls(dataArr)

        },
        findClassNamesByIds(data, idArray) {
            const map = new Map();

            const traverse = (nodes) => {
                for (let item of nodes) {
                    if (!item.children || !Array.isArray(item.children)) {
                        map.set(item.id, item.name);
                    }
                    if (item.children && Array.isArray(item.children)) {
                        traverse(item.children);
                    }
                }
            };

            traverse(data);
            return idArray.map(id => map.get(id)).filter(name => name != null);
        },
        findClassNamesByIdsPuls(idArray) {
            let gradeName = {
                1: '一年级',
                2: '二年级',
                3: '三年级',
                4: '四年级',
                5: '五年级',
                6: '六年级',
            }
            let nameArr = [];
            for (let index = 0; index < idArray.length; index++) {
                const ids = idArray[index].id;
                if (ids == 0) {
                    nameArr.push(gradeName[idArray[index].grade] + idArray[index].name)
                } else {
                    nameArr.push(idArray[index].name)
                }

            }
            console.log('nameArr', nameArr);
            return nameArr;
        },
    },
    // 生命周期，创建完成时（可以访问当前this实例）
    created() {

    },
    // 生命周期：挂载完成时（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { },//生命周期：创建之前
    beforeMount() { },//生命周期：挂载之前
    beforeUpdate() { },//生命周期：更新之前
    updated() { },//生命周期：更新之后
    beforeDestroy() { },//生命周期：销毁之前
    destroyed() { },//生命周期：销毁完成
    activated() { },//如果页面有keep-alive缓存功能，这个函数会触发执行
}
</script>
<style scoped lang="less">
/* 全局样式中 */
::v-deep.el-message--error {
    width: 100px !important;
    width: auto !important;
    /* 自定义宽度 */
    // min-width: auto !important;
    /* 防止被最小宽度覆盖 */
}

::v-deep.confirm-information {
    .el-dialog__header {
        padding: 0 !important;
    }

    .confirm-information-box {

        // border: 1px solid #000;
        display: flex;
        flex-direction: column;
        align-items: center;


        .confirm-information-title {
            font-size: 18px;
            color: #000;
            font-weight: bold;
            padding: 10px 0;
            margin-bottom: 40px;
        }

        .confirm-information-content {
            width: 500px;
            // border: 1px solid #000;
            // height: 250px;
            // border: 1px solid #000;

            .info-item {
                margin-bottom: 20px;
                display: flex;
                align-items: center;
                // border: 1px solid #000;

                &:nth-child(2n) {
                    margin-bottom: 0;
                }
            }

            .el-cascader__tags {
                .el-tag__close {
                    display: none !important;
                }
            }

            .tags-container {
                width: 100%;
                // border: 1px solid #000;
                flex-wrap: wrap;
                height: auto !important;

                .el-tag {
                    margin: 5px 10px;
                    border: 1px solid #7fdbc6;
                    background-color: rgba(179, 240, 226, 0.1);
                    color: #21bd99;
                }
            }

            .info-item-classname {
                box-sizing: border-box;
                padding-left: 85px;
                margin-top: 10px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;

                .el-tag {
                    margin-right: 5px;
                    margin-bottom: 5px;
                }
            }

            .info-name-title {
                width: 100px;
                // height: 35px;
                // border: 1px solid #000;
                font-size: 17px;
                font-weight: bold;
                color: #666666;
            }
        }
    }

    .footer-btn {
        width: 110px;
        height: 40px;
        // border: 1px solid #000;
        font-size: 16px;
        margin: 0 10px;
        margin-bottom: 20px;
        border-radius: 8px;
    }

    .Confirm-btn {
        background: #21BD99;
        color: #fff;
        border: 1px solid #21BD99;
        cursor: pointer;
    }

    .Mod-btn {
        background: #fff;
        color: #8b8888;
        border: 1px solid #7fdbc6;
    }

    .el-input__inner:focus {
        border-color: #21BD99;
    }

    .el-input {
        width: 100% !important;
    }

    .el-select {
        width: 100% !important;
    }

    .el-cascader {
        width: 100% !important;
    }

    .el-input__inner:focus {
        border-color: #21BD99;
    }

    .el-cascader-node.is-active {
        color: #21BD99 !important;
    }

    .el-checkbox__inner {
        background-color: #21BD99 !important;
        color: #000;
    }
}
</style>